import * as React from 'react';

import './style.scss';

const UserExplorerHeadTable = () => {
  return(
    <div className='user-explorer-table-head d-flex align-center justify-between'>
      <div>{'Event Category'}</div>
      <div>{'Event'}</div>
      <div>{'Timestamp'}</div>
    </div>
  );
};

export default UserExplorerHeadTable;
